import React from "react";
import styled from "styled-components";
import NavBar from "../../components/auth/NavBar";
import { useAuth } from "../../utils";

const HomeBannerSection = () => {
  const { isAuthenticated } = useAuth(); // get authentication status and logout function
  return (
    // <h2 style={{ textAlign: "center", height:"70px", padding: "0px", border: "1px dashed black" }}>Banner Area</h2>
    <BannerWrapper>
      {isAuthenticated ? (
        <Title>Hello, Sunny!</Title>
      ) : (
        <Title>What's new</Title>
      )}
      <NavBar />
    </BannerWrapper>
  );
};

export default HomeBannerSection;

const BannerWrapper = styled.div`
  height: 70px;
  padding: 0;
  background-color: var(--app-banner-bg, #171921);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--app-banner-text, #ffffff);
  font-size: 1.5rem;
  font-weight: bold;
  position: relative;
`;

const Title = styled.h2`
  position: absolute;
  color: var(--app-banner-text, #ffffff);
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
`;
